import { ChangeDetectionStrategy, Component, booleanAttribute, input } from '@angular/core';
import { PrefixUrlPipe } from '../../pipes/prefix-url.pipe';

@Component({
  selector: 'eventq-detail-field',
  imports: [PrefixUrlPipe],
  templateUrl: './detail-field.html',
  styleUrl: './detail-field.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.aria-busy]': 'loading() ? "true" : null',
  },
})
export class EventqDetailField {
  readonly label = input.required<string>();
  readonly value = input.required<string>();
  readonly iconSrc = input.required<string>();
  readonly loading = input(false, { transform: booleanAttribute });
}
